import apiClient from "../utils/axios.utils";

const API_BASE = "/newsletter";

export const NewsletterService = {
    async getAllEmails(): Promise<string[]> {
        const res = await apiClient.get<string[]>(`${API_BASE}/emails`);
        return res.data;
    },

    async subscribe(email: string): Promise<{ success: boolean; message: string }> {
        const res = await apiClient.post(`${API_BASE}/subscribe`, { email });
        return res.data;
    }
};